export class ShipUser {
  userUuid = '';
  location = '';
  cardPan: number;
  role = '';
  enabled = true;
}
